<template>
  <div class="h-f bd-EEEEEE mb80">
    <el-aside class="" width="100%">
      
      <div class="w200">
        <div class="">
          <el-menu
            class="bd-none"
            :default-active="default_active"
            text-color="#000" active-text-color="#000" :router="true"
            @select="change"
          >
            <el-menu-item
              class="row ft16 lh36"
              :class="index==0?'pt20 pb14':''"
              v-for="(item,index) in list" :key="index"
              :index="item.path"
            >
              <div class="row a-center ft16 lh36" slot="title">
                <span :class="index==0?'ft16 lh36 c-b font-Bold':'ft16 lh36 c-3 font-Regular'">{{item.name}}</span>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

    </el-aside>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { loginOut } from "@/api/app";
export default {
  name: '',
  components: {

  },
  data() {
    return {
      default_active:'Mine',//关于我们
      list:[
        {name:this.$t('账户总览'),path:'Mine',},
        {name:this.$t('帐户设置'),path:'Setting',},
        {name:this.$t('我的订单'),path:'Orders',},
        {name:this.$t('分销中心'),path:'Share',},
        {name:this.$t('商品收藏'),path:'Collection',},
        {name:this.$t('历史浏览'),path:'History',},
        {name:this.$t('优惠券'),path:'Coupons',},
        {name:this.$t('帮助中心'),path:'Help',},
        {name:this.$t('退出'),path:'',},
      ],
    }
  },
  mounted() {
    
  },
  methods: {
    ...mapActions([
      'changeInfo',
      'changeToken',
    ]),
    // 退出登录
    async handleOut(){
      const {data} = await loginOut();
      if(data.code == 1){
        window.localStorage.removeItem('BuyParams');
        window.localStorage.removeItem('user_remember');
        window.localStorage.removeItem('user_mobile');
        window.localStorage.removeItem('user_pwd');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('userinfo');
        this.changeToken('');
        this.changeInfo({});
        location.reload();
      }else{
        this.$message.error(data.msg);
      }
    },
    async change(e){
      // console.log(e);
      this.default_active = e;
      if(!e){
        this.$confirm(this.$t('确定退出登录吗?'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          customClass:'confirm-w420'
        }).then(() => {
          this.handleOut();
        }).catch(() => {
          
        });
      }
    },
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-menu-item{
  height:fit-content;
  background:#fff;
  padding-left: 1.25vw !important;
}
::v-deep .el-menu-item:hover{
  background:#fff;
}
::v-deep .el-menu-item:nth-of-type(1){
  background:#E5E5E5;
  padding-left: 1.4583vw !important;
}
::v-deep .el-menu-item:nth-of-type(2){
 padding-top:10px;
}
::v-deep .el-menu-item:last-of-type{
 padding-bottom:14px;
}
</style>